import { render, staticRenderFns } from "./BookingAddTraveller.vue?vue&type=template&id=41c72491&"
import script from "./BookingAddTraveller.vue?vue&type=script&lang=js&"
export * from "./BookingAddTraveller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports